const SecondPage = {
  data(){
    return {
        navBarFixed: false, //是否导航吸顶
        tabsEm: -1,
        navTop: 0,
        scrollTop: 60
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.navTop = this.getOffsetTop('pronbit');
      // scroll代表滚动条距离页面顶部距离
      window.addEventListener('scroll', this.dataScroll);
    });
  },
  methods: {
    // 获取导航距离顶部的距离
    getOffsetTop(ref) {
      let offsetHeight =  this.$refs[ref].offsetHeight
      let offsetTop = this.$refs[ref].offsetTop
      return offsetTop - offsetHeight
    },
    dataScroll () {
      const scroll = document.documentElement.scrollTop || document.body.scrollTop;
      this.navBarFixed = scroll > this.navTop - 10;
      if (!this.navBarFixed) {
        this.tabsEm = -1;
      }
      // 用循环的方式将每个标题离顶部的距离与滚动条当前位置对比来确定哪个标题需要变为高亮
      const sections = document.getElementsByClassName('scroll-filed');
      for (let i = sections.length - 1; i >= 0; i--) {
        if (scroll >= sections[i].offsetTop - this.scrollTop - 60) {
          this.tabsEm = i
          break;
        };
      }
    },
    jump(index) {
      let jump = document.getElementsByClassName('scroll-filed');
      // 获取需要滚动的距离
      let domHeight = jump[index].offsetTop - this.scrollTop;
      //页面滚动了的距离
      let height =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //滚动距离计算
      var S = Number(height) - Number(domHeight);
      //判断上滚还是下滚
      if (S < 0) {
        //下滚
        S = Math.abs(S);
        window.scrollBy({ top: S, behavior: "smooth" });
      } else if (S == 0) {
        //不滚
        window.scrollBy({ top: 0, behavior: "smooth" });
      } else {
        //上滚
        S = -S;
        window.scrollBy({ top: S, behavior: "smooth" });
      }
    }
    
  }
}

export  { SecondPage }